<template>
  <div ref="container">
    <a-modal
      title="商品模式选择"
      :width="580"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取 消"
      okText="确 定"
      style="top:150px;">
      <a-form class="model-form">
        <!-- 克隆云贝门店列表"选择模式"弹窗：三模式单选 + 描述文案逐字照抄 -->
        <a-form-item label="选择模式：" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
          <a-radio-group v-model="goodsModel">
            <div class="model-item">
              <a-radio value="1">模式一：同步总店商品</a-radio>
              <div class="model-desc">子门店将和总门店的商品库存、价格保持统一，仅能操作商品上下架，无商品编辑和新增权限</div>
            </div>
            <div class="model-item">
              <a-radio value="2">模式二：普通商品权限</a-radio>
              <div class="model-desc">子门店仅能修改商品库存和价格以及商品上下架，无商品编辑和新增权限</div>
            </div>
            <div class="model-item">
              <a-radio value="3">模式三：超级商品权限</a-radio>
              <div class="model-desc">子门店可操作商品库存和价格、商品上下架，以及新增商品权限，请谨慎开放。</div>
            </div>
          </a-radio-group>
          <div class="model-warn"><span class="warn-strong">特别注意：</span>门店商品权限一旦选择后，请勿随意修改，以免造成门店商品数据错乱</div>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { putAction } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin'

/**
 * 商品模式弹窗（克隆云贝 chunk-481f6809"商品模式选择"弹窗，文案逐字照抄 spec 0.5）
 * API 契约：PUT /api/plugin/dining/stores/{id}/goods-model（body {goodsModel: '1'|'2'|'3'}）
 */
const STORE_PREFIX = '/api/plugin/dining/stores'

export default {
  name: 'DiningGoodsModelModal',
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      storeId: null,
      goodsModel: '1'
    }
  },
  methods: {
    show(record) {
      this.storeId = record.id
      this.goodsModel = String(record.goodsModel || '1')
      this.visible = true
    },
    handleOk() {
      const that = this
      // 云贝保存前二次确认同款警示文案
      this.$confirm({
        title: '操作确认',
        content: '门店商品权限一旦选择后，请勿随意修改，以免造成门店商品数据错乱，请谨慎操作！',
        onOk() {
          that.confirmLoading = true
          return putAction(`${STORE_PREFIX}/${that.storeId}/goods-model`, { goodsModel: that.goodsModel }).then(res => {
            if (res.code === 200) {
              that.$message.success(res.message || '保存成功')
              that.$emit('ok')
              that.visible = false
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.model-item {
  margin-bottom: 20px;
}
.model-desc {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin: 4px 0 0 25px;
}
.model-warn {
  color: #f5222d;
  margin-top: 8px;
  line-height: 20px;
}
.warn-strong {
  font-weight: bold;
}
</style>
